export default "/images/vendor/flag-icon-css/flags/4x3/vi.svg?bad0002a368d6bca0956ab2b5b889145";